import React from 'react';
import { Navigate } from 'react-router-dom';
import { NamesStepView } from './NamesStepView';
import { useNamesStep, type UseNamesStepOptions } from './useNamesStep';

export type NamesStepProps = UseNamesStepOptions;

/**
 * Review names: what to do with the file's new brands, categories and
 * suppliers before the products are checked. The wizard mounts it at
 * `/onboarding/names`; the in-shell import page will mount it with the
 * branch fixed. Renders inside a `CatalogImportProvider`.
 *
 * The names come from the store's preview, so a step that opens without one
 * (the store lives in memory, and a reload empties it) goes back to Upload,
 * which sends the user on to Branch when there is no branch either. That is
 * decided once, as the step opens, as Upload decides it.
 */
export const NamesStep: React.FC<NamesStepProps> = (paths) => {
    const { hasPreview, ...step } = useNamesStep(paths);
    const [openedWithoutPreview] = React.useState(!hasPreview);

    if (openedWithoutPreview) {
        return <Navigate replace to={paths.backPath} />;
    }

    return <NamesStepView {...step} />;
};
